import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import FilmData from "./Components/Main/FilmData.jsx";
import AppWrapper from "./Components/AppWrapper";
import Register from "./Components/Auth/Register";
import Auth from "./Components/Auth/Auth";
import GetEPG from "./Components/Main/GetEPG";
import Image from "./Components/Image.jsx";

function App() {
  const isAuthenticated = () => {
    return (
      localStorage.getItem("mbase.login") &&
      localStorage.getItem("mbase.password") &&
      localStorage.getItem("mbase.token")
    );
  };
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<AppWrapper />} /> */}
        <Route
          path="/"
          element={isAuthenticated() ? <AppWrapper /> : <Navigate to="/auth" />}
        />
        <Route
          path="/auth"
          element={<Auth onAuthSuccess={() => (window.location.href = "/")} />}
        />
        <Route path="*" element={<Navigate to="/" />} />
        <Route
          path="/dev.api.mbase2.idc.md/api/movie/*"
          element={<FilmData />}
        />
        <Route
          path="/image/*"
          element={<Image />}
        />
        <Route path="/met" element={<GetEPG />} />
      </Routes>
    </Router>
  );
}

export default App;
